var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sparkline',{attrs:{"title":"Cost Per Trip","color":"#13B8A6","loading":_vm.loading,"series":_vm.data,"total":_vm.total,"start":_vm.start,"end":_vm.end,"format":function (val) { return ("R" + (val.toFixed(2)) + " ZAR") }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }